import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const companyInfo = [
  { label: '会社名', value: '株式会社ヴェリテ' },
  { label: '英文名', value: 'Verite Inc.' },
  { label: '代表者', value: '苫米地 真美' },
  { label: '所在地', value: '〒980-0802 宮城県仙台市青葉区二日町14-14 二日町ゲートビル2階' },
  { label: '電話', value: '022-211-5488' },
  { label: 'メール', value: 'verite@frise.support' },
  { label: '事業内容', value: '販促物やWebコンテンツを通じた企業・店舗の情報発信支援。Web制作、動画制作、デザイン制作、印刷物制作、BPO・事務作業' },
  { label: 'グループ', value: 'FRISEグループ（フライズグループ）の一員' },
  { label: 'グループURL', value: 'https://frise-group.co.jp/' },
  { label: '就労支援連携', value: '就労継続支援の仕組みを活かしたBPO（データ入力・書類スキャン等）。Web制作・デザインの企画・品質管理はヴェリテが担当' },
  { label: '営業時間', value: '平日 9:00〜18:00（土日祝は翌営業日対応）' },
];

export default function Company() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />

      <section className="pt-24 md:pt-32 pb-16 md:pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full mb-6">
                About Us
              </span>
              <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-6">
                会社概要
              </h1>
            </div>

            {/* Company Info Table */}
            <div className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden mb-12">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <tbody>
                    {companyInfo.map((item, idx) => (
                      <tr
                        key={idx}
                        className={`border-b border-background-200/60 last:border-b-0 ${
                          idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                        }`}
                      >
                        <td className="px-6 py-4 font-semibold text-foreground-700 whitespace-nowrap w-40">
                          {item.label}
                        </td>
                        <td className="px-6 py-4 text-foreground-900 leading-relaxed">
                          {item.label === 'グループURL' ? (
                            <a
                              href={item.value}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-primary-600 hover:text-primary-700 underline break-all cursor-pointer"
                            >
                              {item.value}
                            </a>
                          ) : (
                            item.value
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Supplementary Paragraph */}
            <div className="bg-accent-50 border border-accent-200 rounded-xl p-6 md:p-8">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                株式会社ヴェリテは、FRISEグループ（フライズグループ）の一員として、Web制作・DTP・動画・BPO事業を行っています。グループは障がい者支援・就労支援・訪問看護など、地域で「人と向き合う」事業を展開。ヴェリテは、そのネットワークの中で、制作とIT支援の窓口を担います。
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}